import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { css } from '@compiled/react';

import Heading from '@atlaskit/heading/heading';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import { i18n } from './messages.ts';

const sectionStyles = css({
	marginBottom: token('space.300'),
});

const headerStyles = css({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.100'),
	marginBottom: token('space.150'),
});

/**
 * "Rovo Agents for you" section on Confluence Home / For You.
 *
 * PR1 (CCCEMAU-3070): scaffold only — section shell, header and Labs lozenge.
 * Eligibility/gating and grid + UFOSegment placement are owned by ForYou.tsx, which
 * only mounts this component when eligible. Card UI, dismiss and CTA come in later PRs.
 */
export const RovoAgentsForYou: FC = () => {
	return (
		<section css={sectionStyles} data-testid="rovo-agents-for-you">
			<div css={headerStyles}>
				<Heading size="xsmall" as="h2">
					<FormattedMessage {...i18n.sectionTitle} />
				</Heading>
				<Lozenge appearance="new">
					<FormattedMessage {...i18n.labsLozenge} />
				</Lozenge>
			</div>
		</section>
	);
};
